export default {
	init() {
		// JavaScript to be fired on all pages
		$.fn.lazy = function(settings){
		var config = {};

		if(settings) $.extend(config, settings);

		this.each(function(){
			var me = $(this);
			if(me.hasClass('lazy')) return;

			me.addClass('lazy');
			var __load = function(){
				var view = {
					top: $(window).scrollTop(),
					bottom: $(window).scrollTop() + $(window).height(),
				};

				if((me.offset().top + me.height()) > view.top && me.offset().top < view.bottom){
					me.addClass('loading');

					me.on(function(){
						me.removeClass('loading').removeClass('error').addClass('loaded');
					}).on(function(){
						me.addClass('error');

						setTimeout(function(){
							me.removeClass('loading');
						}, 1000);
					});
					
					if (me.attr('data-src')) {
						me.attr('src', me.attr('data-src'));
						me.removeAttr('data-src');
					} else if (me.attr('data-background-image')){
						me.css('background-image', 'url(\'' + me.attr('data-background-image') + '\')');
						me.removeAttr('data-background-image');
					}
				}
			};

			$(window).on('scroll', function(){ 
				__load(); 
			});

			__load();
		});
	};

	$('img[data-src], div[data-background-image], section[data-background-image], a[data-background-image]').lazy();

	function videoPlay(wrapper) {
		var video = wrapper.find('.content__video');
		var src = video.data('video-src');

		wrapper.addClass('active');
		video.attr('src', src);
		video.attr('controls', true);
	}

	$('.play--video').on('click', function(e) {
		e.preventDefault();
		var poster = $(this);

		var wrapper = poster.closest('.text-media');
		$(this).css('display', 'none');
		videoPlay(wrapper);
	});

	$('.carousel').flickity({
		draggable: true,
		cellAlign: ($(window).width() > 768 ? 'left' : 'center'),
		contain: true,
		wrapAround: false,
		pageDots: false,
		prevNextButtons: true,
		groupCells: true,
	});

		function isTouchDevice() {
		return typeof window.ontouchstart !== 'undefined';
	}

	/* If mobile browser, prevent click on parent nav item from redirecting to URL */
    if(isTouchDevice()) {
		// 1st click, add "clicked" class, preventing the location change. 2nd click will go through.
		$('.menu-item-has-children').click(function(event) {
			// Perform a reset - Remove the "clicked" class on all other menu items
			$('.menu-item-has-children').not(this).removeClass('clicked');
			event.toggleClass('clicked');
			if (event.hasClass('clicked')) {
				event.preventDefault();
			}
		});
	}

	window.onscroll = function() {
		hasScrolled()
	};

    var header = document.getElementById('main-header');
    var content = document.getElementById('main-content');
    var sticky = header.offsetTop;

    // Add the sticky class to the header when you reach its scroll position.
	// Remove "sticky" when you leave the scroll position
    function hasScrolled() {
		if (window.pageYOffset > sticky - 5) {
			header.classList.add('scrolled');
			content.classList.add('scrolled');
		} else {
			header.classList.remove('scrolled');
			content.classList.remove('scrolled');
		}
	}

	$('.main-header__hamburger').on('click', function () {
        $(this).toggleClass('is-open');
		$('body').toggleClass('is-open');
        $('.nav--primary').toggleClass('is-open');
		$('.main-header__search').toggleClass('is-open');
		$('.main-header__login').toggleClass('is-open');
		
		$.each($('.logo'), function() {
			if ($(this).hasClass('show')) {
				$(this).removeClass('show').addClass('hidden');
			} else {
				$(this).removeClass('hidden').addClass('show');
			}
		});
    });

	$('.btn--search').on('click touch', function(e) {
        if (!$('input[name="r"]').val()) { 
			e.preventDefault();
		}
    });

	if($('input[name="form_type"]').val()) {
		$('#input_2_7').val($('input[name="form_type"]').val());
	}

	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
  


// WEBPACK FOOTER //
// ./scripts/routes/common.js